import React from 'react'
import { Outlet } from 'react-router-dom'

function MainFireSuppression() {
  return (
     <div>
       <Outlet/>
     </div>
   )
}

export default MainFireSuppression